/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';
import { Grid } from '@mui/material';
import { StepperInput } from '@care/react-component-lib';
import { useAppDispatch, useSeekerState } from '@/components/AppState';
import { DistanceUnit } from '@/__generated__/globalTypes';
import Header from '@/components/Header';
import { SxClassProps } from '@/types/common';

const classes: SxClassProps = {
  distanceInputContainer: {
    '& > div': {
      padding: 0,
      maxWidth: '100%',
    },
  },
};

function TravelDistance() {
  const dispatch = useAppDispatch();
  const daycareDistanceFromState = useSeekerState().maxDistanceFromSeekerDayCare.distance;

  const daycareDistance = { increment: 2, initialValue: 10, maximum: 50, minimum: 2 };

  useEffect(() => {
    if (daycareDistanceFromState === 0) {
      dispatch({
        type: 'setMaxDistanceFromSeekerDayCare',
        distance: 2,
        unit: DistanceUnit.MILES,
      });
    }
  }, []);

  const onDistanceInputChange = (distance: number) => {
    dispatch({
      type: 'setMaxDistanceFromSeekerDayCare',
      distance,
      unit: DistanceUnit.MILES,
    });
  };
  return (
    <>
      <Grid item xs={12} pt={1} pb={3}>
        <Header>How far are you willing to travel?</Header>
      </Grid>
      <Grid item xs={12} py={2} sx={classes.distanceInputContainer}>
        <StepperInput
          name="distance"
          min={daycareDistance.minimum}
          max={daycareDistance.maximum}
          inc={daycareDistance.increment}
          initialVal={2}
          optionalLabel="miles"
          onChange={onDistanceInputChange}
        />
      </Grid>
    </>
  );
}

export { TravelDistance };
